import LiftUpCarousel from "./LiftUpCarousel.vue";

bootVue('.vue-liftup-carousel', LiftUpCarousel);
